'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var dagPB = require('ipld-dag-pb');

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

module.exports = function (_ref) {
  var ipld = _ref.ipld,
      preload = _ref.preload;

  var get = require('./get')({
    ipld: ipld,
    preload: preload
  });

  return withTimeoutOption( /*#__PURE__*/function () {
    var _stat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(multihash, options) {
      var node, serialized, cid, blockSize, linkLength;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              _context.next = 3;
              return get(multihash, options);

            case 3:
              node = _context.sent;
              serialized = dagPB.util.serialize(node);
              _context.next = 7;
              return dagPB.util.cid(serialized, {
                cidVersion: 0
              });

            case 7:
              cid = _context.sent;
              blockSize = serialized.length;
              linkLength = node.Links.reduce(function (a, l) {
                return a + l.Tsize;
              }, 0);
              return _context.abrupt("return", {
                Hash: cid.toBaseEncodedString(),
                NumLinks: node.Links.length,
                BlockSize: blockSize,
                LinksSize: blockSize - node.Data.length,
                DataSize: node.Data.length,
                CumulativeSize: blockSize + linkLength
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function stat(_x, _x2) {
      return _stat.apply(this, arguments);
    }

    return stat;
  }());
};